import { combineReducers } from "redux";
import currencyReducer from "./currencySetting.reducer";
import timezoneReducer from "./timezoneSetting.reducer";
import dummyDataReducer from "./dummyAccountSetting.reducer";

export default combineReducers({
  currency: currencyReducer,
  timezone: timezoneReducer,
  excludeDummyAccount: dummyDataReducer
});
